export const MAX_POSITION_AMOUNT = 1000;
export const MAX_DIGITAL_POSITION_AMOUNT = 1;
